import React from "react";

const emptyExperience = {
  companyname: "",
  location: "",
  designation: "",
  joiningDate: "",
  relievingDate: "",
  experience: "",
};

const ExperienceDetails = ({ data, setData, errors = [] }) => {

  const calculateExperience = (joiningDate, relievingDate) => {
    if (!joiningDate || !relievingDate) return "";

    const start = new Date(joiningDate);
    const end = new Date(relievingDate);

    const diff = end - start;

    const years = Math.floor(diff / (1000 * 60 * 60 * 24 * 365));
    const months = Math.floor(
      (diff % (1000 * 60 * 60 * 24 * 365)) /
      (1000 * 60 * 60 * 24 * 30)
    );

    return `${years}y ${months}m`;
  };

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updated = [...data];

    updated[index][name] = value;

    if (name === "joiningDate" || name === "relievingDate") {
      const joining = updated[index].joiningDate;
      const relieving = updated[index].relievingDate;

      updated[index].experience = calculateExperience(joining, relieving);
    }

    setData(updated);
  };

  const addExperience = () => {
    setData([...data, { ...emptyExperience }]);
  };

  const removeExperience = (index) => {
    const updated = data.filter((_, i) => i !== index);
    setData(updated);
  };

  return (
    <>
      {data.map((exp, index) => (
        <div key={index} className="border rounded p-3 mb-4">
          <h6>Experience {index + 1}</h6>

          <div className="row g-3">

            <div className="col-lg-4">
              <label>Company Name *</label>
              <input
                name="companyname"
                className="form-control"
                value={exp.companyname}
                onChange={(e) => handleChange(index, e)}
              />
            </div>

            <div className="col-lg-4">
              <label>Location *</label>
              <input
                name="location"
                className="form-control"
                value={exp.location}
                onChange={(e) => handleChange(index, e)}
              />
            </div>

            <div className="col-lg-4">
              <label>Designation *</label>
              <input
                name="designation"
                className="form-control"
                value={exp.designation}
                onChange={(e) => handleChange(index, e)}
              />
            </div>

            <div className="col-lg-4">
              <label>Joining Date *</label>
              <input
                type="date"
                name="joiningDate"
                className="form-control"
                value={exp.joiningDate}
                onChange={(e) => handleChange(index, e)}
              />
            </div>

            <div className="col-lg-4">
              <label>Relieving Date *</label>
              <input
                type="date"
                name="relievingDate"
                className="form-control"
                value={exp.relievingDate}
                onChange={(e) => handleChange(index, e)}
              />
            </div>

            <div className="col-lg-4">
              <label>Experience</label>
              <input
                className="form-control"
                value={exp.experience}
                readOnly
              />
            </div>

            {/* ✅ Remove Button */}
            <div className="col-12">
              <button
                type="button"
                className="btn1111 btn-danger"
                onClick={() => removeExperience(index)}
                disabled={data.length === 1}
              >
                Remove
              </button>
            </div>

          </div>
        </div>
      ))}

      {/* ✅ Add Button */}
      <button
        type="button"
        className="btn btn-outline-primary mt-2"
        onClick={addExperience}
      >
        Add Another Experience +
      </button>
    </>
  );
};

export default ExperienceDetails;